// src/POIIcon.tsx
import { jsx } from "react/jsx-runtime";
var POIIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20.48 20.48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.24 20.256C5.168 20.256 0.016 19.168 0.016 17.088c0 -1.856 3.968 -2.624 5.664 -2.864h0.064c0.24 0 0.448 0.176 0.48 0.416 0.016 0.128 -0.016 0.256 -0.096 0.352s-0.192 0.176 -0.32 0.192c-3.536 0.512 -4.848 1.44 -4.848 1.92 0 0.896 3.616 2.208 9.264 2.208S19.488 18 19.488 17.104c0 -0.48 -1.328 -1.408 -4.896 -1.92 -0.128 -0.016 -0.24 -0.08 -0.32 -0.192 -0.08 -0.096 -0.112 -0.224 -0.096 -0.352 0.032 -0.24 0.24 -0.416 0.48 -0.416h0.064c1.712 0.24 5.712 1.008 5.712 2.864 0.016 2.064 -5.12 3.168 -10.192 3.168m-0.336 -3.392c-0.24 -0.224 -5.776 -5.456 -5.776 -10.592 0 -3.36 2.736 -6.096 6.096 -6.096S16.32 2.912 16.32 6.272c0 4.992 -5.536 10.352 -5.776 10.576l-0.32 0.32zM10.24 1.136c-2.832 0 -5.136 2.304 -5.136 5.136 0 4.016 3.92 8.32 5.136 9.552 1.232 -1.264 5.152 -5.648 5.152 -9.552 -0.016 -2.816 -2.32 -5.136 -5.152 -5.136m0 7.856c-1.6 0 -2.896 -1.296 -2.896 -2.896S8.64 3.2 10.24 3.2s2.896 1.296 2.896 2.896S11.84 8.992 10.24 8.992m0 -4.832c-1.072 0 -1.936 0.864 -1.936 1.936s0.864 1.936 1.936 1.936 1.936 -0.864 1.936 -1.936 -0.88 -1.936 -1.936 -1.936",
        fill: "currentColor"
      }
    )
  }
);
var POIIcon_default = POIIcon;

export {
  POIIcon_default
};
